var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('TemplateCreateWizardProgressBar',{staticClass:"mb-4"}):_vm._e(),(!_vm.isLoading)?_c('TemplateCreateWizardDialog',{on:{"templateSaved":_vm.onTemplateSaved}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }